(ns app.admin.user-remove)

(defn get-invites [user-id workspace]
  (->> workspace
       :entity/_parent
       (mapcat (fn [phase]
                 (->> phase
                      :invite/_application
                      (remove (comp #{:invite.status/accepted
                                      :invite.status/declined
                                      :invite.status/withdrawn}
                                    :invite/status))
                      (filter (fn [invite]
                                (-> invite
                                    :invite/user
                                    :db/id
                                    (= user-id)))))))))
